<template lang="html">
  <div class="notice">
    <div class="cover" v-show="!active">
      <span class="edit" @click="edit">{{message.Sl127}}</span>
    </div>
    <div class="form">
      <div class="cell-title">{{message.Sl221}}:</div>
      <el-checkbox v-model="form.ck1" :label="message.Nl107"></el-checkbox>
      <el-checkbox v-model="form.ck2" :label="message.Nl108"></el-checkbox>
      <el-checkbox v-model="form.ck10" :label="message.Nl116"></el-checkbox>
      <el-checkbox v-model="form.ck3" :label="message.Nl109"></el-checkbox>
      <el-checkbox v-model="form.ck4" :label="message.Nl110"></el-checkbox>
      <el-checkbox v-model="form.ck5" :label="message.Nl111"></el-checkbox>
      <el-checkbox v-model="form.ck6" :label="message.Nl112"></el-checkbox>
      <el-checkbox v-model="form.ck7" :label="message.Nl113"></el-checkbox>
      <div class="cell-title">{{message.Sl222}}:</div>
      <el-checkbox v-model="form.ck11" :label="message.Nl117"></el-checkbox>
      <el-checkbox v-model="form.ck13" :label="message.Nl119"></el-checkbox>
      <el-checkbox v-model="form.ck8" :label="message.Sl219"></el-checkbox>
      <el-checkbox v-model="form.ck9" :label="message.Sl220"></el-checkbox>
      <div style="padding-top:20px;text-align:center;margin-bottom:20px" v-show="active">
       <el-button style="width:80px" size='small' type="primary" @click="onSubmit">&nbsp;&nbsp;{{message.Fl126}}&nbsp;&nbsp;</el-button>
       <el-button style="width:80px" size='small' @click="reset">{{message.Fl101}}</el-button>
     </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      message: {
        Nl107: this.$lang.ui.notice.l107,
        Nl108: this.$lang.ui.notice.l108,
        Nl109: this.$lang.ui.notice.l109,
        Nl110: this.$lang.ui.notice.l110,
        Nl111: this.$lang.ui.notice.l111,
        Nl112: this.$lang.ui.notice.l112,
        Nl113: this.$lang.ui.notice.l113,
        Nl116: this.$lang.ui.notice.l116,
        Nl117: this.$lang.ui.notice.l117,
        Nl119: this.$lang.ui.notice.l119,
        Sl131: this.$lang.ui.system.l131,
        Fl101: this.$lang.ui.form.l101,
        Fl126: this.$lang.ui.form.l126,
        Sl127: this.$lang.ui.system.l127,
        Sl219: this.$lang.ui.system.l219,
        Sl220: this.$lang.ui.system.l220,
        Sl221: this.$lang.ui.system.l221,
        Sl222: this.$lang.ui.system.l222
      },
      active: false,
      data: '',
      form: {
        ck1: '',
        ck2: '',
        ck3: '',
        ck4: '',
        ck5: '',
        ck6: '',
        ck7: '',
        ck8: '',
        ck9: '',
        ck10: '',
        ck11: '',
        ck12: '',
        ck13: ''
      }
    }
  },
  mounted () {
    this.noticeList()
  },
  methods: {
    view () {
      var data = JSON.parse(JSON.stringify(this.data)).sub_pkgevts
      if (data.indexOf('new') !== -1) {
        this.form.ck1 = true
      } else {
        this.form.ck1 = false
      }
      if (data.indexOf('finish_own_upload') !== -1) {
        this.form.ck2 = true
      } else {
        this.form.ck2 = false
      }
      if (data.indexOf('finish_own_download') !== -1) {
        this.form.ck3 = true
      } else {
        this.form.ck3 = false
      }
      if (data.indexOf('start_downloading') !== -1) {
        this.form.ck4 = true
      } else {
        this.form.ck4 = false
      }
      if (data.indexOf('finish_downloading') !== -1) {
        this.form.ck5 = true
      } else {
        this.form.ck5 = false
      }
      if (data.indexOf('upload_pkg_delete') !== -1) {
        this.form.ck6 = true
      } else {
        this.form.ck6 = false
      }
      if (data.indexOf('download_pkg_delete') !== -1) {
        this.form.ck7 = true
      } else {
        this.form.ck7 = false
      }
      if (data.indexOf('transfer_error') !== -1) {
        this.form.ck8 = true
      } else {
        this.form.ck8 = false
      }
      if (data.indexOf('account_kickout') !== -1) {
        this.form.ck9 = true
      } else {
        this.form.ck9 = false
      }
      if (data.indexOf('finish_archive') !== -1) {
        this.form.ck10 = true
      } else {
        this.form.ck10 = false
      }
      if (data.indexOf('failed_archive') !== -1) {
        this.form.ck11 = true
      } else {
        this.form.ck11 = false
      }
      if (data.indexOf('failed_retrieve') !== -1) {
        this.form.ck13 = true
      } else {
        this.form.ck13 = false
      }
    },
    onSubmit () {
      var events = []
      if (this.form.ck1) {
        events.push('new')
      }
      if (this.form.ck2) {
        events.push('finish_own_upload')
      }
      if (this.form.ck3) {
        events.push('finish_own_download')
      }
      if (this.form.ck4) {
        events.push('start_downloading')
      }
      if (this.form.ck5) {
        events.push('finish_downloading')
      }
      if (this.form.ck6) {
        events.push('upload_pkg_delete')
      }
      if (this.form.ck7) {
        events.push('download_pkg_delete')
      }
      if (this.form.ck8) {
        events.push('transfer_error')
      }
      if (this.form.ck9) {
        events.push('account_kickout')
      }
      if (this.form.ck10) {
        events.push('finish_archive')
      }
      if (this.form.ck11) {
        events.push('failed_archive')
      }
      if (this.form.ck13) {
        events.push('failed_retrieve')
      }
      this.$http.put('/cydex/api/v1/settings/events', {
        'settings': {
          'sub_pkgevts': events,
          'pub_methods': ['email']
        }
      })
        .then(response => {
          this.noticeList()
          this.$message({
            message: this.$lang.ui.prompt.l118,
            type: 'success',
            duration: 4000
          })
        })
    },
    edit () {
      this.view()
      this.active = true
    },
    reset () {
      this.view()
      this.active = false
    },
    noticeList () {
      this.$api.getNotice(response => {
        this.active = false
        this.data = response
        this.view()
      })
    }
  }
}
</script>

<style lang="css" scoped>
.notice{
  position: relative;
  margin: 0 auto;
  padding: 25px 25px;
  padding-top: 0;
  overflow: hidden;
  border-radius: 4px;
  background-color: #f0f0f0;
}
.form {
  padding-left: 10px;
  text-align: left;
  width: 100%;
}
.form .el-checkbox {
  margin: 4px 20px;
  width: 100%;
}
.cover {
  position: absolute;
  z-index: 2;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
}
.edit {
  position: absolute;
  cursor: pointer;
  color: #007bc5;
  top: 20px;
  right: 25px;
  display: block;
  font-size: 14px;
  font-weight: 600;
}
.cover:hover .edit {
  display: block;
}
.el-form-item {
  margin-bottom: 2px;
}
.el-input {
  position: absolute;
  left: 0;
}
.cell-title {
  height: 38px;
  line-height: 114px;
}
.el-checkbox {
  width: 100%;
  height: 30px;
  padding-left: 120px;
  line-height: 30px;
}
</style>
